angular
    .module('webcomm')
    .factory('wtcpjsClientProviderService', ['$log', '$timeout', '$rootScope', 'version', function ($log, $timeout, $rootScope, version) {
        let client;
        let webCommLicenseUUID = "{576386DF-4D31-49B4-97F1-BAF8EECE19B5}";

        function checkForMicrophone() {
            if (client.WTCPAudioStatus.status === 'inprogress') {
                $timeout(checkForMicrophone, 200);
                return;
            }

            if (client.WTCPAudioStatus.status !== 'ready') {
                $log.warn('Could not get microphone access');
                $rootScope.noMicrophone = true;
                $rootScope.$broadcast('client.noMicrophone');
            }
        }

        let service = {

            epFilterMaxNumEndpoints: 128,
            epFilterMaxNumChanEndpointsDisable: 256,
            createClient() {
                $log.warn("wtcpjsClientProviderService: creating a new client");
                // 'webcomm_logging_level' is a global - it comes directly from index.html
                client = new WtcpJs.Client({
                    audioPlayerActive: false,
                    licenseUUID: webCommLicenseUUID,
                    deviceId: this.getDeviceId(),
                    applicationName: `MOT-WEBCOMM-${version}`,
                    loggingLevel: webcomm_logging_level});
                checkForMicrophone(client);
                return client;
            },

            getClient() {
                return client;
            },

            filterTypes: {
                channelFilter: 1,
                privateCallChannelFilter: 2,
                privateCallChannelSelfFilter: 22, // This can go away now with latest trunk build proxy... it supports regex
                addressBookFilter: 7
            },

            getDeviceId() {
                return `webcomm-browser-${Math.random().toString(36).slice(2)}`;
            },

            setEndpointFilterThresholds(configInfo) {
                if(configInfo.endpoint_filter) {
                    this.epFilterMaxNumEndpoints = configInfo.endpoint_filter.maxnumendpoints;
                    this.epFilterMaxNumChanEndpointsDisable = configInfo.endpoint_filter.maxnumchanendpointsdisable;
                }
            }
        }

        return service;
    }]);